import { useEffect, useState } from "react";
import SystemModal from "../Common/SystemModal";
import toast, { Toaster } from "react-hot-toast";
import ajaxDeliveryNotes from "../../util/remote/ajaxDeliveryNotes";

const DeliveryNoteDetailsModal = ({ data, org }) => {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchDetails = async () => {
    if (!data?.id) return;
    setLoading(true);

    try {
      const server_response = await ajaxDeliveryNotes.fetchDeliveryNoteDetails({
        NoteID: data.id,
      });
      if (server_response.status === "OK") {
        setDetails(server_response.details ?? {});
      } else {
        toast.error(server_response.message || "Failed to fetch details");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error fetching delivery note details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, [data?.id]);

  const orgInfo = {
    name: "LA_PROCURE AFRICA LIMITED",
    lines: [
      "P.O.BOX 28775 KAMPALA",
      "PLOT 79B BOMBO ROAD",
      "TEL: +256701666160",
      "EMAIL: info@laprocure.africa",
    ],
    logoSrc: `${process.env.PUBLIC_URL}/assets/img/brand/icon-light.png`,
    watermarkSrc: `${process.env.PUBLIC_URL}/assets/img/brand/icon-light.png`,
    ...org,
  };

  const preloadImages = async () => {
    const images = [orgInfo.logoSrc, orgInfo.watermarkSrc];
    return Promise.all(
      images.map(
        (src) =>
          new Promise((res) => {
            const img = new Image();
            img.src = src;
            img.onload = res;
            img.onerror = res;
          })
      )
    );
  };

  const Print = async (e) => {
    e.preventDefault();
    await preloadImages();

    const html = document.getElementById("printablediv").innerHTML;
    const w = window.open("", "printWindow");
    w.document.open();
    w.document.write(`
      <html>
        <head>
          <title>Delivery Note</title>
          <style>${baseStyles(orgInfo.watermarkSrc)}</style>
        </head>
        <body>${html}</body>
      </html>
    `);
    w.document.close();
    w.focus();
    w.print();
    w.onafterprint = () => w.close();
  };

  const RenderFooter = (controls) => (
    <>
      <button className="btn ripple btn-dark" onClick={controls.close}>
        Close
      </button>
      <button className="btn ripple btn-dark" onClick={Print}>
        Print
      </button>
    </>
  );

  if (loading || !details) return <div>Loading...</div>;

  return (
    <SystemModal
      title="Delivery Note Details"
      id="modal-delivery-note"
      size="xl"
      footer={RenderFooter}
    >
      <Toaster />
      <style>{baseStyles(orgInfo.watermarkSrc)}</style>
      <div id="printablediv">
        <div className="doc">
          <div className="doc-content">
            <div className="doc-header">
              <div className="logo-wrap">
                <img src={orgInfo.logoSrc} alt="Logo" />
              </div>
              <div className="org-text">
                <div className="org-name">{orgInfo.name}</div>
                {orgInfo.lines.map((l, i) => (
                  <div key={i} className="org-line">
                    {l}
                  </div>
                ))}
              </div>
            </div>

            <div className="title">DELIVERY NOTE</div>

            <div className="delivery-info">
              <div>
                <b>Delivery Ref No:</b> {details.delievery_reff_no}
              </div>
              <div>
                <b>Comment:</b> {details.comment}
              </div>
              <div>
                <b>Delivered By:</b> {details.Delivered_by || "Pending"}
              </div>
              <div>
                <b>Date Created:</b> {details.date_created}
              </div>
            </div>

            <table className="items">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Description</th>
                  <th>Quantity</th>
                </tr>
              </thead>
              <tbody>
                {details.items.map((it, idx) => (
                  <tr key={it.id}>
                    <td>{idx + 1}</td>
                    <td>{it.item_name}</td>
                    <td>{it.quantity}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="signature">
              <div>
                <b>Authorized By:</b>
              </div>
              <div className="line"></div>
            </div>
          </div>

          <div className="footer-print">
            Printed on: {new Date().toLocaleString()}
          </div>
        </div>
      </div>
    </SystemModal>
  );
};

const baseStyles = (watermarkSrc) => `
* { box-sizing: border-box; }
body { font-family: Arial, sans-serif; margin: 0; padding: 0; }
.doc { position: relative; padding: 18mm 15mm; min-width: 210mm; max-width: 210mm; margin: 0 auto; background: #fff; border: 1px solid #e5e7eb; display: flex; flex-direction: column; min-height: 100%; }
.doc::before { content: ""; position: absolute; inset: 0; background: url("${watermarkSrc}") no-repeat center center !important; background-size: 60%; opacity: 0.2; z-index: 0; }
.doc-content { flex: 1; display: flex; flex-direction: column; position: relative; z-index: 1; }
.doc-header { display: flex; align-items: center; gap: 16px; margin-bottom: 12px; position: relative; z-index: 2; }
.logo-wrap img { width: 120px; height: 120px; object-fit: contain; }
.org-text { flex: 1; text-align: center; }
.org-name { font-size: 20px; font-weight: 700; letter-spacing: .5px; }
.org-line { font-size: 12px; line-height: 1.2; }
.title { text-align: center; font-size: 18px; font-weight: 700; margin: 12px 0; }
.delivery-info { margin-bottom: 16px; font-size: 13px; line-height: 1.4; }
table { border-collapse: collapse; width: 100%; margin-top: 10px; }
th, td { border: 1px solid #111; padding: 6px 8px; font-size: 12.5px; }
th { background: #f2f2f2; text-align: left; }
.signature { margin-top: 30px; }
.signature .line { margin-top: 16px; border-bottom: 1px solid #111; width: 60%; height: 20px; }
.footer-print { margin-top: 18px; font-size: 11px; text-align: right; color: #374151; }
@page { size: A4; margin: 12mm; }
`;

export default DeliveryNoteDetailsModal;
